import React from "react"
import { ThemeSettings } from "./utils/theme-settings"
import { NoSettings } from "./utils/no-settings"
import { useParentSection } from "../../section/utils/use-parent-section"

const HEADINGS = {
  "heading-one": "h1",
  "heading-two": "h2",
  "heading-three": "h3",
  "heading-four": "h4",
  "heading-five": "h5",
  "heading-six": "h6"
}

export function HeadingSettings({ block_id, node }) {
  const section = useParentSection(block_id)

  if (!section) return <NoSettings />

  return (
    <ThemeSettings
      type={HEADINGS[node.type]}
      section={section}
      showTextTransform
    />
  )
}
